import Reveal from "@/components/common/Reveal";
import WordsReveal from "@/components/motion/WordsReveal";
import SparkleEyebrow from "@/components/motion/SparkleEyebrow";
import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";
import FloatingDecor from "@/components/motion/FloatingDecor";

export const PageHero = ({ eyebrow, title, subtitle, image, imageAlt, testId }) => {
  const reduced = usePreferStaticUI();

  return (
    <section className="relative" data-testid={testId}>
      <div className="wit-section-wide relative py-8 lg:py-12">
        <div className={`grid gap-10 items-center ${image ? "lg:grid-cols-2" : ""}`}>
          <div>
            {eyebrow && (
              <Reveal y={6}>
                <SparkleEyebrow>{eyebrow}</SparkleEyebrow>
              </Reveal>
            )}
            <WordsReveal
              as="h1"
              text={title}
              className="font-serif text-4xl sm:text-5xl lg:text-[3.25rem] leading-[1.06] text-ink"
              stagger={0.04}
              duration={0.55}
              delay={0.06}
            />
            {!reduced && (
              <motion.div
                className="mt-6 h-px max-w-xs bg-gradient-to-r from-raspberry/50 via-plum/30 to-transparent"
                initial={{ scaleX: 0, originX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, ease: "easeOut", delay: 0.3 }}
              />
            )}
            {subtitle && (
              <Reveal delay={0.2}>
                <p className="mt-4 wit-body max-w-xl sm:text-base">
                  {subtitle}
                </p>
              </Reveal>
            )}
          </div>
          {image && (
            <Reveal delay={0.12} className="relative">
              <FloatingDecor range={6} duration={8}>
                <div className="wit-glass-strong overflow-hidden aspect-[4/3] max-w-lg ml-auto">
                  <img src={image} alt={imageAlt || title || ""} className="w-full h-full object-cover" />
                </div>
              </FloatingDecor>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
